module.exports = __webpack_public_path__ + "static/img/15.28173ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/15.png
// module id = lIbP
// module chunks = 0